import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string().required("Por favor digite seu email"),
    password: Yup.string().required("Por favor digite sua senha")
  }),
  mapPropsToValues: props => {
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";
    return {
      email: isLocalhost ? process.env.REACT_APP_DEV_LOGIN_EMAIL || "" : "",
      password: isLocalhost
        ? process.env.REACT_APP_DEV_LOGIN_PASSWORD || ""
        : ""
    };
  },
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
